export default function PatagoniaAddCategory({
  children
}) {
  return children;
}